import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouter} from 'next/router';
import {getApiService} from 'redux/services/HttpService';
import Api from 'constants/Api';
import AppFooter from './AppFooter';
import MobileNavigation from './components/MobileNavigation';
import MobileBottomNavigation from './components/MobileBottomNavigation';
import MobileUserProfile from 'components/profile/MobileUserProfile';
import ReactHtmlParser from 'react-html-parser';

import {handleChangeDrawerState} from 'redux/actions/ThemeActions';
import {purifyMessage} from '../helpers/UrlHelper';
import {NotificationHelper} from '../helpers/NotificationHelper';

import {Drawer, Layout, message} from 'antd';
import Skeleton from 'react-loading-skeleton';
import {IoCloseSharp} from 'react-icons/io5'
import Goftino from './components/Goftino';
import ThemeSwitch from '../common/ThemeSwitch';
import moment from 'moment-jalaali';
import _ from 'lodash';

import ProfileDrawerStyles from 'components/profile/styles/mobile-user-profile.module.scss'
import SupportDrawerStyles from './styles/support-drawer.module.scss'

const NotificationDrawer = ({drawerState}) => {
    const router = useRouter()
    const [notifications, setNotifications] = useState(null)
    const [forceNotifications, setForceNotifications] = useState()

    const renderItemIcon = (item) => {
        switch (item.action_object_content_type) {
            case NotificationHelper.notificationContentType.trading:
                return <div
                    className={'w-[40px] h-[40px] rounded-full bg-navy-blue-200 flex items-center justify-center'}>
                    <img alt={`آیکون ارز ${NotificationHelper.retrieveCryptoFromDesc(item)}`}
                         width={24}
                         src={`/images/icons/crypto/${NotificationHelper.retrieveCryptoFromDesc(item).toLowerCase()}.svg?v=2`}/>
                </div>;
            case NotificationHelper.notificationContentType.general:
                return <div
                    className={'w-[40px] h-[40px] rounded-full bg-navy-blue-200 flex items-center justify-center'}>
                    <img alt={item.verb}
                         width={24}
                         src={item.action_object_image}/>
                </div>;
            case NotificationHelper.notificationContentType.credit_card:
                return <div
                    className={'w-[40px] h-[40px] rounded-full bg-navy-blue-200 flex items-center justify-center'}>
                    <img alt={item.verb}
                         width={24}
                         src={'/images/icons/card-change-status.svg'}/>
                </div>;

            default:
                return <div
                    className={'w-[40px] h-[40px] rounded-full bg-navy-blue-200 flex items-center justify-center'}/>;
        }
    }

    const renderItem = (item) => {
        if (NotificationHelper.supportedTypes.includes(item.action_object_content_type))
            return <div className={
                'py-6 border-0 border-solid border-b-[1px] last:border-b-0 last:pb-0 border-[var(--horizontal-divider)] ' +
                'flex flex-row gap-[16px]'
            }>
                <div>{renderItemIcon(item)}</div>
                <div>
                    <p className={'mb-1 font-semibold'}>{item.verb}</p>
                    <p className={'mb-2 text-[var(--text-color-scondary)]'}>{ReactHtmlParser(purifyMessage(item.description).withHtml)}</p>
                    <p className={'mb-0 numeric-content text-[#7c8399] text-sm font-light'}>{
                        moment(item.timestamp, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').format('jYYYY/jM/jD HH:mm:ss')
                    }</p>
                </div>
            </div>
    }

    const retrieveUserNotifications = async () => {
        try {
            let retNotifications = await getApiService(Api.NOTIFICATION_GET_ALL, false);

            if (retNotifications.success === false) {
                message.error({
                    content: 'خطایی در دریافت اطلاعات اعلان‌ها پیش آمده است',
                    className: 'ant-message-bg-error'
                });
            } else {
                let {results: notificationsResponse} = retNotifications.data
                setNotifications(notificationsResponse.all_list)

                getApiService(Api.NOTIFICATION_MARK_AS_READ, false).then()
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (drawerState)
            retrieveUserNotifications().then()
    }, [drawerState])

    useEffect(() => {
        try {
            if (typeof window !== 'undefined')
                if (window.location.hash.substr('1') === 'redirected') {
                    setForceNotifications([
                        {
                            "id": 1,
                            "actor_content_type": 1,
                            "verb": "جایگزینی نسخه جدید پینگی با موفقیت انجام شد",
                            "description": "برای تجربه کاربری بهتر، لطفا وب اپ را مجدد روی دستگاه ذخیره کنید.",
                            "action_object_content_type": 0,
                            "action_object_image": `${Api.PWA_URL}/logo/pingi-en-minimal.svg`,
                            "timestamp": "2024-02-26T16:31:04.146348Z",
                            "public": true
                        }
                    ])
                } else {
                    setForceNotifications([
                        {
                            "id": 1,
                            "actor_content_type": 1,
                            "verb": "جایگزینی نسخه جدید پینگی با موفقیت انجام شد",
                            "description": "برای تجربه کاربری بهتر، نسبت به بروزرسانی اپلیکیشن و وب اپ اقدام کنید.",
                            "action_object_content_type": 0,
                            "action_object_image": `${Api.PWA_URL}/logo/pingi-en-minimal.svg`,
                            "timestamp": "2024-02-26T16:31:04.146348Z",
                            "public": true
                        }
                    ])
                }
        } catch (e) {
            // Nothing
        }
    }, [])

    return _.isNull(notifications) ?
        <>
            <Skeleton
                baseColor={'var(--place-holder-one)'}
                highlightColor={'var(--place-holder-two)'}
                height={40}/>
            <Skeleton
                baseColor={'var(--place-holder-one)'}
                highlightColor={'var(--place-holder-two)'}
                height={40}/>
            <Skeleton
                baseColor={'var(--place-holder-one)'}
                highlightColor={'var(--place-holder-two)'}
                height={40}/></>
        :
        <div className={'flex flex-col'}>
            {
                forceNotifications.concat(notifications).map(item => {
                    return renderItem(item)
                })
            }
        </div>
}

function MobileAppLayout({
                             children,
                             disableNavigation,
                             disableHeaderNavigation,
                             showMenu,
                             showBack,
                             forceBack,
                             activeMenu,
                             pageTitle
                         }) {
    const dispatch = useDispatch()
    const {Content} = Layout;
    const router = useRouter()
    const ThemeState = useSelector(state => state.Theme)
    const contentRef = useRef(null)

    const hideDrawer = (type = 'drawer') => {
        switch (type) {
            case 'drawer':
                dispatch(handleChangeDrawerState({showDrawer: false}))
                return;
            case 'support':
                dispatch(handleChangeDrawerState({showSupportDrawer: false}))
                return;
            case 'notification':
                dispatch(handleChangeDrawerState({showNotificationDrawer: false}))
                return;
        }
    }

    useEffect(() => {
        if (typeof window !== "undefined") {
            contentRef.current.scrollTop = 0;
        }
    }, [router])

    return <Layout className={
        `layout mobile-layout ${disableNavigation && 'bottom-navigation-hide'} ${disableHeaderNavigation && 'header-navigation-hide'} ${ThemeState.theme}-theme`
    }>
        {
            !disableHeaderNavigation && <MobileNavigation pageTitle={pageTitle} showMenu={showMenu}
                                                          showBack={showBack} forceBack={forceBack}/>
        }
        <Content ref={contentRef}>
            {children}
        </Content>
        {
            !disableNavigation && <MobileBottomNavigation activeMenu={activeMenu} logoutOnly={false}/>
        }
        <AppFooter disableFooter={true}/>

        <Drawer
            title={<ThemeSwitch/>}
            closeIcon={<IoCloseSharp/>}
            className={ProfileDrawerStyles.user_profile}
            placement={'right'}
            width={'100%'}
            onClose={() => hideDrawer('drawer')}
            open={ThemeState.showDrawer}>
            <MobileUserProfile hideDrawer={() => hideDrawer('drawer')}/>
        </Drawer>
        <Goftino open={ThemeState.showSupportDrawer}/>
        <Drawer
            closeIcon={<IoCloseSharp/>}
            className={SupportDrawerStyles.support_drawer}
            placement={'left'}
            width={'100%'}
            onClose={() => hideDrawer('notification')}
            open={ThemeState.showNotificationDrawer}>
            <NotificationDrawer drawerState={ThemeState.showNotificationDrawer}/>
        </Drawer>
    </Layout>
}

export default MobileAppLayout
